var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPermissionMotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.711 8.12305L17.8917 10.1804L20.9202 10.4476C21.5063 10.4142 21.6659 11.5831 20.6271 11.6833C19.6958 11.6833 17.7842 11.7371 16.8304 11.7658C16.6734 11.7703 16.52 11.7164 16.3986 11.614C16.2773 11.5116 16.1961 11.3677 16.17 11.2087L15.9704 9.67941",
    stroke: "#485058",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6733 17.1097C12.3134 18.5155 9.5901 21.2845 9.5901 21.2845C8.82679 21.9728 7.64341 21.0404 8.52102 20.0211C9.171 19.2652 11.1835 17.0576 11.1835 17.0576",
    stroke: "#485058",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5846 7.40858C20.7716 7.40858 21.7339 6.42168 21.7339 5.20429C21.7339 3.98689 20.7716 3 19.5846 3C18.3976 3 17.4354 3.98689 17.4354 5.20429C17.4354 6.42168 18.3976 7.40858 19.5846 7.40858Z",
    stroke: "#485058",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2718 6.97449H2.19913",
    stroke: "#485058",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19891 8.94531H8.4154",
    stroke: "#485058",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31792 11.049H2.19913",
    stroke: "#485058",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19913 13.0529H10.2718",
    stroke: "#485058",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46414 3.90156L12.6711 3.4066C12.888 3.38122 13.1068 3.43413 13.2898 3.55622L16.0832 5.41952C16.2656 5.54152 16.4182 5.70507 16.529 5.89745L17.5984 7.36196C17.7293 7.58986 17.7694 7.86076 17.7105 8.11826C17.6515 8.37575 17.498 8.6 17.2818 8.74432L13.3478 11.5431C13.3202 11.5615 13.2965 11.5852 13.278 11.613C13.2594 11.6408 13.2465 11.6721 13.2398 11.7051C13.2331 11.738 13.2328 11.7721 13.239 11.8051C13.2452 11.8382 13.2577 11.8697 13.2758 11.8978L15.7748 15.8582C16.1271 16.3491 15.8399 17.1053 15.1235 17.0939C14.1466 17.1196 8.4153 17.0939 8.4153 17.0939C7.54356 17.0365 7.3358 16.0789 8.0115 15.6197C8.18645 15.5037 8.38937 15.4397 8.59766 15.435L12.7297 15.3071C12.7501 15.3071 12.77 15.3014 12.7875 15.2906C12.8049 15.2799 12.8192 15.2645 12.8288 15.2461C12.8385 15.2278 12.843 15.207 12.8421 15.1862C12.8412 15.1653 12.8347 15.1451 12.8235 15.1277L10.1738 11.0488C10.1738 11.0488 9.5456 10.0031 10.4668 9.1117C10.7137 8.87257 13.365 6.99525 14.0714 6.49528C14.091 6.48133 14.1072 6.46278 14.1185 6.44115C14.1299 6.41952 14.136 6.39544 14.1364 6.3709C14.1369 6.34636 14.1316 6.32206 14.1211 6.30001C14.1106 6.27797 14.0951 6.25881 14.0759 6.24412L12.8313 5.28993C12.7022 5.19082 12.5452 5.13728 12.3839 5.1373H8.43158C7.60119 5.1373 7.40581 4.10195 8.46414 3.90156Z",
    stroke: "#485058",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPermissionMotion);
export default __webpack_public_path__ + "static/media/ic_permission_motion.9598e8d91ad417e20689b090ae8adb11.svg";
export { ForwardRef as ReactComponent };